import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ModuleLayout from "./ModuleLayout/ModuleLayout";
import { vendorValidationSchema } from "./FormModal/validationSchemas";

const createVendorInitialValues = () => ({
  _id: "",
  name: "",
  contactPerson: "",
  phone: "",
  email: "",
  address: "",
  notes: "",
});

const prepareVendorFormValues = (vendor = {}) => ({
  ...createVendorInitialValues(),
  ...vendor,
  _id: vendor._id || "",
  name: String(vendor.name || "").trim(),
  contactPerson: String(vendor.contactPerson || "").trim(),
  phone: String(vendor.phone || "").trim(),
  email: String(vendor.email || "").trim(),
  address: String(vendor.address || "").trim(),
  notes: String(vendor.notes || "").trim(),
});

const buildVendorPayload = (values = {}) => ({
  ...values,
  name: String(values.name || "").trim(),
  contactPerson: String(values.contactPerson || "").trim(),
  phone: String(values.phone || "").trim(),
  email: String(values.email || "").trim(),
  address: String(values.address || "").trim(),
  notes: String(values.notes || "").trim(),
});

const vendorFields = [
  { name: "name", label: "Vendor Name", type: "text" },
  { name: "contactPerson", label: "Contact Person", type: "text" },
  { name: "phone", label: "Phone", type: "text" },
  { name: "email", label: "Email", type: "email" },
  {
    name: "address",
    label: "Address",
    type: "text",
    multiline: true,
    rows: 2,
  },
  {
    name: "notes",
    label: "Notes",
    type: "text",
    multiline: true,
    rows: 3,
  },
];

function Vendors() {
  const vendorInit = createVendorInitialValues();

  const searchFilter = (vendor, search) => {
    if (!search) return true;
    const term = search.toLowerCase();
    return [
      vendor.name,
      vendor.contactPerson,
      vendor.phone,
      vendor.email,
      vendor.address,
      vendor.notes,
    ].some((value) => String(value || "").toLowerCase().includes(term));
  };

  const sortFunction = (a, b) =>
    String(a?.name || "").localeCompare(String(b?.name || ""), undefined, {
      sensitivity: "base",
    });

  const getItemName = (vendor) => vendor?.name || "";

  const columns = [
    {
      field: "serial",
      headerName: "Sr. #",
      width: 70,
      sortable: false,
      filterable: false,
    },
    { field: "name", headerName: "Vendor Name", minWidth: 170 },
    { field: "contactPerson", headerName: "Contact", minWidth: 150 },
    { field: "phone", headerName: "Phone", minWidth: 140 },
    { field: "email", headerName: "Email", minWidth: 180 },
    {
      field: "address",
      headerName: "Address",
      minWidth: 220,
      renderCell: ({ value }) => value || "-",
    },
    {
      field: "updatedAt",
      headerName: "Updated",
      minWidth: 120,
      renderCell: ({ value }) =>
        value ? new Date(value).toLocaleDateString() : "-",
    },
  ];

  const breadcrumbs = [
    {
      label: "Home",
      path: "/user/dashboard",
      icon: <HomeIcon sx={{ mr: 0.5, fontSize: 20 }} />,
    },
    {
      label: "Settings",
      path: "/user/settings",
      icon: <SettingsIcon sx={{ mr: 0.5, fontSize: 20 }} />,
    },
    {
      label: "Vendors",
      path: null,
      icon: <StorefrontIcon sx={{ mr: 0.5, fontSize: 20 }} />,
    },
  ];

  return (
    <ModuleLayout
      moduleName="Vendors"
      moduleKey="vendors"
      icon={<StorefrontIcon sx={{ fontSize: 34, color: "white" }} />}
      initialFormValues={vendorInit}
      formFields={vendorFields}
      validationSchema={vendorValidationSchema}
      onBeforeSave={buildVendorPayload}
      mapItemToFormValues={prepareVendorFormValues}
      columns={columns}
      searchFilter={searchFilter}
      sortFunction={sortFunction}
      getItemName={getItemName}
      breadcrumbs={breadcrumbs}
      moduleDescription="Manage vendor records and keep vendor names centralized"
      deleteWarning="Deleting a vendor also clears that vendor name from matching parts, tires, oils, and filters."
    />
  );
}

export default Vendors;
